import React from "react"
import { Button } from "reactstrap"
import styles from "./EventTab.module.scss"

export default function EventTab({
	setActiveTab,
	selectedEvent,
	setSelectedEvent,
	selectedPlayerText,
	setFollowupPlayer,
	setFollowupEvent,
	normalEvents,
}) {
	const onSelectEvent = (event) => {
		setSelectedEvent(event)
		setFollowupPlayer({})
		setFollowupEvent()
		if (event.followup) {
			setActiveTab(3)
		}
	}

	const createEventBtn = (event, index) => {
		const isSelectedEvent = selectedEvent.name == event.name
		return (
			<Button.Ripple
				key={`eventButton-${index}`}
				color="primary"
				size="lg"
				outline={!isSelectedEvent}
				onClick={() => onSelectEvent(event)}
			>
				{event.name}
			</Button.Ripple>
		)
	}

	return (
		<>
			{/* <FollowupModal openModal={openModal} /> */}
			<h1 className={styles.selectedPlayerText}>{selectedPlayerText}</h1>
			<div className={styles.grid}>{normalEvents?.map(createEventBtn)}</div>
		</>
	)
}
